import moment from 'moment';
import { TIMER } from './constants';

class Formats {
  static formatCurrency(value) {
    if (!value) return '';

    let val = value.replace(/[^\d]/g, '');

    if (val.length === 1) {
      val = val.replace(/(\d{1}).*/g, '0,0$1');
    } else if (val.length < 3) {
      val = val.replace(/([0-9]{2}).*/g, '0,$1');
    } else if (val.length > 2) {
      val = val.replace(/^0/g, '');
      val = val.replace(/([\d]{2})$/g, ',$1');
      val = val.replace(/(\d)(?=(\d{3})+\b)/g, '$1.');
    }
    val = `R$ ${val}`;
    return val;
  }

  static formatDate(timestamp) {
    let date = moment(timestamp).format('DD/MM/YYYY');
    const currentDate = moment(new Date()).format('DD/MM/YYYY');

    if (currentDate === date) {
      date = `hoje, ${moment(timestamp).format('HH:mm')}`;
    } else {
      date = moment(timestamp).format('DD/MM/YY, HH:mm');
    }

    return date;
  }

  static formatQuantity(amount) {
    if (amount === 0.66) {
      return '2/3';
    } else if (amount === 0.5) {
      return '1/2';
    } else if (amount === 0.33) {
      return '1/3';
    } else if (amount === 0.25) {
      return '1/4';
    } else if (amount === 0.2) {
      return '1/5';
    }
    return amount;
  }

  static getTimerValue(id) {
    return TIMER.find(item => item.value === id);
  }
}

export default Formats;



// WEBPACK FOOTER //
// ./src/helpers/formats.js